module.exports = __webpack_public_path__ + "static/media/folha4.98f596c4.png";